
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import EventBus from '../../eventBus'
  import { required } from 'vuelidate/lib/validators'
  import { Validations } from 'vuelidate-property-decorators'
  
  @Component
  export default class ManageWellFluidType extends Vue {
      @Validations()
      validations = {
          wellFluidType: {
              property: { required },
          }
      }
      activeScreen: string = 'main'
      loadingMessage: string = 'Please wait while we create new fluid type'
      loadingTitle: string = 'Saving...'
      additionalSuccessMessage: string = ''
      successMessage: string = 'New Fluid Type Created Successfully'
      links: Array<object> = [
          {
              text: 'Chart Settings',
              to: '/chart-settings'
          },
          {
              text: 'Manage Well Fluid Type',
              active: true
          }
      ]
      error: any = {
          generalMessage: '',
          errors: []
      }
      wellFluidType: any = {
          property: '',
          backgroundColor: '',
          textColor: '',
      }
      activeItem: any = null
      formErrors: string[] = []
  
  
      // METHODS
      checkErrors() {
          this.formErrors = []
  
          if(this.wellFluidType.property.length < 1) {
              this.formErrors.push('Well Fluid Type is Required')
          }
      }
      
      newActivity(){
          this.wellFluidType.property = '';
          this.$v.$reset()
      }
  
      persistData(){
          this.activeScreen = 'loading';
          EventBus.$emit('activeScreen', this.activeScreen)        
          if(this.activeItem == null)
              this.saveNew();
          else
              this.update();
      }
  
      update(){
          this.activeScreen = 'loading'
          EventBus.$emit('activeScreen', this.activeScreen)
          this.loadingMessage = 'Please wait while we update this fluid type'
          this.loadingTitle = 'Saving...'
          var payload = this.createPayload()
          this.$store.dispatch('settingsModule/updateColorSetting', payload)
          .then((res: any) => 
              {
                  this.activeScreen = 'successNoGotIt'
                  EventBus.$emit('activeScreen', this.activeScreen)
                  this.additionalSuccessMessage = ''
                  this.successMessage = 'Fluid Type Updated Successfully'
              }
          ).catch((err: any) => {
              this.activeScreen = 'error'
              EventBus.$emit('activeScreen', this.activeScreen)
              this.error.generalMessage = err.message
          })
      }
   
      createPayload() {
          return {
              settingType: 'FluidType',
              propertyName: this.wellFluidType.property,
              id: this.activeItem ? this.activeItem.id : 0,
              backgroundColor:  typeof(this.wellFluidType.backgroundColor)=='string'?this.wellFluidType.backgroundColor:this.wellFluidType.backgroundColor.hex,
              textColor:  typeof(this.wellFluidType.textColor)=='string'?this.wellFluidType.textColor:this.wellFluidType.textColor.hex,
          }
      }
  
      saveNew(){
          var payload = this.createPayload()
          this.$store.dispatch('settingsModule/mutateColorSetting', [payload])
          .then((res: any) =>
              {
                  this.activeScreen = 'successRemain'
                  EventBus.$emit('activeScreen', this.activeScreen)
                  this.additionalSuccessMessage = 'You can now use the newly fluid type'
                  this.successMessage = 'Successfully Created '+ payload.propertyName
                  this.newActivity()
              }
          ).catch((err: any) => {
              this.activeScreen = 'error'
              EventBus.$emit('activeScreen', this.activeScreen)
              this.error.generalMessage = err.message
          })
      }
  
  
  
      // VUEX METHODS
  
      // COMPUTED PROPERTIES
      get getWellSettings () {
        return this.$store.getters['settingsModule/getSettingsWell']
    }
    get fetchColorSettings() {
        return this.$store.dispatch('settingsModule/getColorSettings')
    }
      
      get isButtonDisabled(): boolean {
          if (this.formErrors.length > 0) {
              return true
          } else {
              return false
          }
      }
  
      // CREATED
      created() {
        this.fetchColorSettings.then(() => {
            if(this.$route.query.id){
                this.activeItem = this.getWellSettings.find((i: any) => i.id == this.$route.query.id)

                this.wellFluidType.property = this.activeItem.propertyName,
                this.wellFluidType.backgroundColor = this.activeItem.backgroundColor;
                this.wellFluidType.textColor = this.activeItem.textColor;
          }else{
              this.checkErrors()
          }
        });
      }
  }
  
  